var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bc-public-create-project-link"},[_c('router-link',{staticClass:"fs-13",attrs:{"to":"/projects/new"}},[_vm._v(" "+_vm._s(_vm.$t('profile.publicprojects.createProject'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }